import axios from "axios";
import endpoints from "../utils/endpoints";

const redirectShortUrl = async (shortcode: string) => {
  const url = endpoints.SHORT_URL(shortcode);
  
  const response = await axios.get(url);
  return response;
};

const urlService = {
  redirectShortUrl,
};

export default urlService;
